export function formatEventStart(start) {
  const date = new Date(start);

  const dateOptions = {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
  };

  const timeOptions = {
    hour: "2-digit",
    minute: "2-digit",
  };

  const dateStr = date.toLocaleDateString("es-ES", dateOptions);
  const timeStr = date.toLocaleTimeString("es-ES", timeOptions);

  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  return {
    date: capitalize(dateStr),
    time: timeStr,
  };
}